import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const ServiceArea = [
  { label: "Fevzi Çakmak Koltuk Yıkama", path: "/esenler/fevzi-cakmak-koltuk-yikama" },
  { label: "Fevzi Çakmak Yorgan Yıkama", path: "/esenler/fevzi-cakmak-yorgan-yikama" },
  { label: "Menderes Koltuk Yıkama", path: "/esenler/menderes-koltuk-yikama" },
  { label: "Menderes Battaniye Yıkama", path: "/esenler/menderes-battaniye-yikama" },
  { label: "Kazım Karabekir Koltuk Yıkama", path: "/esenler/kazim-karabekir-koltuk-yikama" },
  { label: "Kazım Karabekir Yerinde Yıkama", path: "/esenler/kazim-karabekir-yerinde-yikama" },
  { label: "Nine Hatun Koltuk Yıkama", path: "/esenler/nine-hatun-koltuk-yikama" },
  { label: "Nine Hatun Perde Yıkama", path: "/esenler/nine-hatun-perde-yikama" },
  { label: "Tuna Mahallesi Koltuk Yıkama", path: "/esenler/tuna-koltuk-yikama" },
  { label: "Tuna Mahallesi Kuru Temizleme", path: "/esenler/tuna-kuru-temizleme" },
  { label: "Esenler Merkez Koltuk Yıkama", path: "/esenler/merkez-koltuk-yikama" }
];

const EsenlerServiceArea = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="text-[#003132] mt-0 w-full">
      <div
        onClick={toggleDropdown}
        className="cursor-pointer flex items-center justify-between bg-[#e2e8f0] p-3 rounded-lg shadow-md hover:bg-[#d1d5db]"
      >
        <h2 className="text-lg font-semibold uppercase tracking-wide">
          ESENLER HİZMET TÜRLERİ
        </h2>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {isOpen && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full mt-2">
          {ServiceArea.map((area, index) => (
            <Link
              key={index}
              to={area.path}
              className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-green-700 text-white"
                  : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
              }`}
            >
              {area.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default EsenlerServiceArea;
